import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchReceiptsDetail} from 'api/documents';
import {rootDomain} from 'core/rootDomain';
import {ReceiptDetailRaw} from 'types/documents';

const domain = rootDomain.createDomain('ReceipsDetailDomain');
export const ReceiptsDetailGate = createGate<{id: string}>('ReceiptsDetailGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchReceiptsDetail',
    handler: fetchReceiptsDetail,
});

export const commonData$ = domain.createStore<ReceiptDetailRaw | null>(null);

export const commonDataState$ = combine({
    data: commonData$,
    isLoading: fetchDataFx.pending,
});
